export default __webpack_public_path__ + "static/media/demo.525d22dc.jpg";